import maFormImport from './components/formImport'
import maFormExport from './components/formExport'
import maModal from '@/components/modal'
import * as Api from '@/services/API/admin'
import * as Blobs from '@/infra/blobs'

const IDLE_STATUS_TYPE = Symbol('IDLE_STATUS_TYPE')
const DONE_STATUS_TYPE = Symbol('DONE_STATUS_TYPE')
const PROCESSING_STATUS_TYPE = Symbol('PROCESSING_STATUS_TYPE')
const SELECTED_STATUS_TYPE = Symbol('SELECTED_STATUS_TYPE')
const ERROR_STATUS_TYPE = Symbol('ERROR_STATUS_TYPE')
const PROCESS_STATUS_TIMEOUT = 2000

const mapFormProccessStatus = ({ status, meta }) => {
  if (status === 'idle' && meta?.url != null) {
    return { status: DONE_STATUS_TYPE, meta }
  }

  if (status === 'idle' && meta?.url == null) {
    return { status: IDLE_STATUS_TYPE, meta: null }
  }

  if (status === 'processing') {
    return { status: PROCESSING_STATUS_TYPE, meta: null }
  }

  if (status === 'error') {
    return { status: ERROR_STATUS_TYPE, meta: null }
  }
}

let statusInterval = null
export default {
  name: 'adminForms',
  data () {
    return {
      status: null,
      statusMeta: null,
      isLoading: false,
      showImport: true,
      filterFormOptions: [{ key: null, literal: this.$t('common.noSelected') }],
      mimetype: Blobs.mimeTypes.EXCEL,
      importForm: {
        filter: null,
        file: null,
        key: 1
      },
      exportForm: {
        filter: null,
        key: 1
      }
    }
  },
  components: {
    maFormImport,
    maFormExport,
    maModal
  },
  computed: {
    importFormEvents () {
      return {
        onHandleImportFilterChange: this.handleImportFilterChange,
        onHandleImportFileUpload: this.handleImportFileUpload,
        onHandleImportFileDelete: this.handleImportFileDelete,
        onHandleResetImportData: this.handleResetImportData,
        onHandleImportFormClick: this.handleImportFormClick
      }
    },
    exportFormEvents () {
      return {
        onHandleExportFilterChange: this.handleExportFilterChange,
        onHandleExportFormClick: this.handleExportFormClick,
        onHandleResetExportData: this.handleResetExportData
      }
    }
  },
  methods: {
    async setFilterFormsOptions () {
      try {
        const filterFormOptionsApiArray = await Api.apiGetFormFilters()
        this.filterFormOptions = [
          ...this.filterFormOptions,
          ...filterFormOptionsApiArray.map((filter) => ({ key: filter.id, literal: filter.literal }))
        ]
      } catch (e) {
        console.error(e)
      }
    },
    async getFormProcessStatus () {
      try {
        const response = await Api.apiGetFormProcessStatus()
        const { status, meta } = mapFormProccessStatus(response)
        this.status = status
        if (meta != null) {
          this.statusMeta = meta
        }
      } catch (e) {
        console.error(e)
        this.status = ERROR_STATUS_TYPE
      }
    },
    handleProcessingStatusEnd () {
      clearInterval(statusInterval)
      statusInterval = null
      this.$refs.adminFormModal.showModal = false
      this.isLoading = false
      this.handleResetExportData()
      this.handleResetImportData()
      this.status = IDLE_STATUS_TYPE
    },
    handleImportFilterChange (event) {
      this.importForm.filter = event
    },
    handleImportFileUpload (event) {
      this.importForm.file = event
    },
    handleImportFileDelete () {
      this.importForm.file = null
    },
    handleResetImportData () {
      this.importForm.filter = null
      this.importForm.file = null
      this.importForm.key += 1
    },
    async postFormFile () {
      const blob = await Blobs.fileToBlob(this.importForm.file)
      try {
        await Api.apiPostFormFile({
          id: this.importForm.filter,
          blob: Blobs.removeMimeHeader(blob)
        }).then(() => this.getFormProcessStatus())
      } catch (e) {
        console.error(e)
        this.status = ERROR_STATUS_TYPE
      }
    },
    async handleImportFormClick () {
      this.isLoading = true
      this.status = SELECTED_STATUS_TYPE
      await this.postFormFile()
    },

    handleExportFilterChange (event) {
      this.exportForm.filter = event
    },
    async getFormFileExport () {
      try {
        await Api.apiGetFormFile({
          id: this.exportForm.filter
        })
      } catch (e) {
        console.error(e)
        this.status = ERROR_STATUS_TYPE
      }
    },
    async handleExportFormClick () {
      this.isLoading = true
      this.status = PROCESSING_STATUS_TYPE
      await this.getFormFileExport()
    },
    handleResetExportData () {
      this.exportForm.filter = null
      this.exportForm.key += 1
    }
  },
  watch: {
    async status (newValue, oldValue) {
      if (newValue === IDLE_STATUS_TYPE) {
        this.handleProcessingStatusEnd()
        oldValue === PROCESSING_STATUS_TYPE && this.throwNotification('', this.$t('adminForms.toast.success'), 'OK')
      }

      if (newValue === DONE_STATUS_TYPE) {
        try {
          await Api.apiDownloadFormFile(this.statusMeta.url)
          this.throwNotification('', this.$t('adminForms.toast.success'), 'OK')
          this.handleProcessingStatusEnd()
        } catch (e) {
          console.error(e)
          this.status = ERROR_STATUS_TYPE
        }
      }

      if (newValue === ERROR_STATUS_TYPE) {
        this.handleProcessingStatusEnd()
        this.throwNotification('', this.$t('adminForms.toast.error'), 'KO')
      }

      if (newValue === SELECTED_STATUS_TYPE) {
        this.$refs.adminFormModal.showModal = true
      }

      if (newValue === PROCESSING_STATUS_TYPE) {
        this.$refs.adminFormModal.showModal = true
        statusInterval = setInterval(this.getFormProcessStatus, PROCESS_STATUS_TIMEOUT)
      }
    }
  },
  async beforeMount () {
    await this.setFilterFormsOptions()
    await this.getFormProcessStatus()
  }
}
